// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "hashed-1/" + (chunkId === 66586 ? "griffel" : chunkId) + "-" + {"60891":"8317c890fc","66586":"d39dbca4fa"}[chunkId] + ".css";
};